import { Box, Flex, Heading, Text } from "@chakra-ui/react";

import LandingNavbar from "../landing/components/LandingNavbar";
import MarketingFooter from "../marketing/components/MarketingFooter";

const ACCENT = "#04aec1";
const ACCENT_MID = "#6366f1";

const LegalPageLayout = ({
  eyebrow = "Legal",
  title,
  effectiveDate,
  children,
}) => (
  <Box
    bg="#ffffff"
    color="#0a0e1a"
    fontFamily="'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
    minH="100vh"
    overflowX="hidden"
    sx={{ WebkitFontSmoothing: "antialiased" }}
  >
    <LandingNavbar />

    <Box
      as="section"
      position="relative"
      overflow="hidden"
      bg={`linear-gradient(160deg, ${ACCENT}, ${ACCENT_MID})`}
      color="white"
      px={{ base: "20px", md: "28px" }}
      pt={{ base: "40px", md: "56px" }}
      pb={{ base: "44px", md: "60px" }}
    >
      <Box
        position="absolute"
        inset={0}
        pointerEvents="none"
        sx={{
          backgroundImage: "url('/navbar_bg.png')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          opacity: 0.35,
          mixBlendMode: "screen",
        }}
      />
      <Box
        position="absolute"
        inset={0}
        pointerEvents="none"
        sx={{
          background:
            "radial-gradient(ellipse at 30% 50%, rgba(0,0,0,0.18), transparent 60%)",
        }}
      />

      <Flex
        position="relative"
        zIndex={2}
        direction="column"
        gap="14px"
        maxW="960px"
        mx="auto"
      >
        {eyebrow && (
          <Box
            alignSelf="flex-start"
            display="inline-flex"
            fontSize="11px"
            fontWeight={700}
            letterSpacing="0.16em"
            textTransform="uppercase"
            padding="5px 12px"
            borderRadius="9999px"
            bg="rgba(255,255,255,0.16)"
            border="1px solid rgba(255,255,255,0.30)"
            backdropFilter="blur(8px)"
            color="white"
          >
            {eyebrow}
          </Box>
        )}
        <Heading
          as="h1"
          m={0}
          fontSize={{ base: "32px", md: "44px" }}
          lineHeight="1.1"
          letterSpacing="-0.025em"
          fontWeight={700}
          sx={{ textShadow: "0 2px 12px rgba(0,0,0,0.18)" }}
        >
          {title}
        </Heading>
        {effectiveDate && (
          <Text
            m={0}
            fontSize="14px"
            color="rgba(255,255,255,0.85)"
            fontWeight={500}
          >
            Effective {effectiveDate}
          </Text>
        )}
      </Flex>
    </Box>

    <Box
      as="main"
      bg="#ffffff"
      px={{ base: "20px", md: "28px" }}
      py={{ base: "48px", md: "72px" }}
    >
      <Box
        maxW="760px"
        mx="auto"
        sx={{
          "& h2": {
            fontSize: { base: "20px", md: "22px" },
            fontWeight: 700,
            letterSpacing: "-0.01em",
            color: "#0a0e1a",
            mt: "36px",
            mb: "10px",
          },
          "& h2:first-of-type": { mt: 0 },
          "& p, & li": {
            fontSize: "15px",
            lineHeight: "1.7",
            color: "rgba(15,22,38,0.78)",
            mb: "10px",
          },
          "& strong": { color: "#0a0e1a" },
          "& a": {
            color: ACCENT,
            textDecoration: "none",
            borderBottom: "1px solid",
            borderColor: `${ACCENT}55`,
            transition: "border-color .2s",
          },
          "& a:hover": { borderColor: ACCENT },
          "& ul": { pl: "20px", mb: "16px" },
          "& li": { listStyle: "disc", mb: "6px" },
        }}
      >
        {children}
      </Box>
    </Box>

    <MarketingFooter />
  </Box>
);

export default LegalPageLayout;
